class BookingRecommendationViewController extends SingleEditViewController
{    
    static newInstance() : BookingRecommendationViewController {
        let vc = new BookingRecommendationViewController("single-edit-view");
        vc.initWithResource("layout/base/SingleEditView.html");
        return vc;
    }

    get title(){
        return MIOLocalizeString("BOOKING_RECOMMENDATION_CONCEPTS", "BOOKING RECOMMENDATION CONCEPTS");
    }

    fetchEntity(){
        return "BookingRecommendation";
    }

    sortDescriptors(){
        return [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
    }

    configureCellAtIndexPath(cell:SingleEditCell, indexPath:MIOIndexPath, item:MIOManagedObject){
        let d = item as BookingRecommendation;
        cell.setItem(d, "name");
    }

    addButtonDidPress(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_RECOMMENDATION_CONCEPT", "NEW RECOMMENDATION CONCEPT"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
           textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD","ADD"), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let d = MIOEntityDescription.insertNewObjectForEntityForName(this.fetchEntity(), ad.managedObjectContext) as Department;                
            d.name = name;    
            
            ad.managedObjectContext.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, null, null));        

        this.presentViewController(avc, true);
    }

    removeItem(item:MIOManagedObject){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.managedObjectContext.deleteObject(item);
        ad.managedObjectContext.save();        
    }
}